import React, { Component } from 'react';
/* eslint-disable */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import DownIcon from 'mdi-react/ChevronDownIcon';
import {
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	UncontrolledDropdown,
} from 'reactstrap';
import TopbarNavLink from './TopbarNavLink';
import TopbarNavCategory from './TopbarNavCategory';
const initialstate = {
	showrecsnow: localStorage.viewrecruiter,
};
class TopbarNavCompany extends Component {
	constructor(props) {
		super(props);
		localStorage.viewrecruiter;
	}
	state = { ...initialstate };
	handleCkey = () => {
		localStorage.setItem('viewrecruiter', '');
		location.assign('/dashboard');
	};
	render() {
		return (
			<nav className="topbar__nav">
				<UncontrolledDropdown className="topbar__nav-dropdown">
					<DropdownToggle className="topbar__nav-dropdown-toggle">
						Team <DownIcon />
					</DropdownToggle>
					{/* 	<DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
				<DropdownItem>
					<TopbarNavLink title="Reports" icon="home" route="/reportspage" />
				</DropdownItem>
				<DropdownItem>
					<TopbarNavLink
						title="Weekly Report"
						icon="store"
						route="/reportseven"
					/>
				</DropdownItem> 
			</DropdownMenu>*/}
				</UncontrolledDropdown>
				<UncontrolledDropdown className="topbar__nav-dropdown">
					<DropdownToggle className="topbar__nav-dropdown-toggle">
						Reports <DownIcon />
					</DropdownToggle>
					<DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
						<DropdownItem>
							<TopbarNavLink
								title="Reports"
								icon="layers"
								route="/reportspage"
							/>
						</DropdownItem>
						<DropdownItem>
							<TopbarNavLink
								title="Weekly Report"
								icon="layers"
								route="/reportseven"
							/>
						</DropdownItem>
					</DropdownMenu>
				</UncontrolledDropdown>
				{this.state.showrecsnow && this.state.showrecsnow ? (
					<UncontrolledDropdown className="topbar__nav-dropdown">
						<DropdownToggle className="topbar__nav-dropdown-toggle">
							Screening
							<DownIcon />
						</DropdownToggle>

						<DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
							<DropdownItem>
								<TopbarNavCategory title="Phone Screen" icon="smart-phone">
									<TopbarNavLink title="Add Test" route="/recruiter/addtest" />
									<TopbarNavLink
										title="Saved Tests"
										route="/recruiter/savetest"
									/>
									<TopbarNavLink
										title="Sent Tests"
										route="/recruiter/senttests"
									/>
									<TopbarNavLink
										title="Completed Tests"
										route="/recruiter/comtest"
									/>
								</TopbarNavCategory>
							</DropdownItem>
							{/* <DropdownItem>
								<TopbarNavCategory title="Custom Tests" icon="smart-phone">
									<TopbarNavLink
										title="Add Custom Test"
										route="/recruiter/addcustomtest"
									/>
									<TopbarNavLink
										title="UnSaved Test List"
										route="/recruiter/mycustoms"
									/>
									<TopbarNavLink
										title="Saved Test List"
										route="/recruiter/customsavedtest"
									/>
									<TopbarNavLink
										title="Sent Test List"
										route="/recruiter/customsenttest"
									/>
									<TopbarNavLink
										title="Completed Custom Tests"
										route="/recruiter/cuscomtest"
									/>
								</TopbarNavCategory>
							</DropdownItem> */}
						</DropdownMenu>
					</UncontrolledDropdown>
				) : null}
				{this.state.showrecsnow && this.state.showrecsnow ? (
					<div
						style={{ cursor: 'pointer' }}
						onClick={this.handleCkey}
						className="topbar__nav-link"
					>
						Back to Dashboard
					</div>
				) : null}
			</nav>
		);
	}
}

export default TopbarNavCompany;
